module.exports = __webpack_public_path__ + "static/img/main-banner1.689fc5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main-banner1.png
// module id = zeIt
// module chunks = 36